import {css} from 'styled-components'

const lato = 'Lato'
const merriweather = 'Merriweather'

export const theme = {
  typography: {
    lato: lato,
    merriweather: merriweather,
    latoBold: {
      fontFamily: lato,
      fontWeight: 700
    },
    latoReg: {
      fontFamily: lato,
      fontWeight: 400
    },
    latoLite: {
      fontFamily: lato,
      fontWeight: 300
    },
    merriweatherBold: {
      fontFamily: merriweather,
      fontWeight: 700
    },
    merriweatherReg: {
      fontFamily: merriweather,
      fontWeight: 400
    },
    merriweatherLite: {
      fontFamily: merriweather,
      fontWeight: 300
    }
  },
  fontSizes: {
    h1Desktop: {
      fontSize: '72px',
      lineHeight: '44px'
    },
    h1Mobile: {
      fontSize: '46px',
      lineHeight: '60px'
    },
    h2Desktop: {
      fontSize: '24px',
      lineHeight: '36px'
    },
    h2Mobile: {
      fontSize: '25px',
      lineHeight: '32px'
    }
  },
  // http://chir.ag/projects/name-that-color/#<<number>>
  colors: {
    alto: '#DEDEDE',
    blazeOrange: '#FF6600',
    bgGray: 'rgba(216, 216, 216, 0.13)', // #D8D8D8
    darkGray: '#666666',
    black: '#000000',
    brightBlue: '#0099FF',
    cash: '#505053',
    disabled: '#C8C8C8',
    emerald: '#3ED854',
    gizmo: '#BABABA',
    lochmara: '#0072BF',
    madison: '#092761',
    mercuryBlue: '#007ACC',
    pepper: '#222223',
    royalBlue: '#205FE6',
    smalt: '#003594',
    shadow: '#F8F8F8',
    woodyBrown: '#3C2F2D',
    white: '#FFFFFF',
    yellow: '#FFBE2E',
    context: {
      success: '#00BE29',
      failure: '#E2231A',
      attention: '#FFC827'
    },
    accent: {
      begonia: '#FE5147',
      chocolate: '#403330',
      latte: '#51403D',
      luna: '#F9E89E',
      penny: '#BB6E55'
    }
  },
  zIndex: {
    buttonFixed: 10,
    mediaManager: 50,
    modal: 80,
    alert: 100
  },
  limits: {
    componentMaxWidth: '1440px'
  }
}

const breakpoints = {
  xsmall: 350,
  small: 768,
  medium: 1024,
  large: 1280,
  xlarge: 1400
}

// Iterate through the sizes and create a media template
export const maxWidth = Object.keys(breakpoints).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${breakpoints[label] - 1}px) {
      ${css(...args)}
    }
  `
  return acc
}, {})

export const minWidth = Object.keys(breakpoints).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${breakpoints[label]}px) {
      ${css(...args)}
    }
  `
  return acc
}, {})
